import uid from 'lodash/uniqueId';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { put } from 'redux-saga/effects';

import * as Actions from '../../actions';
import Button from '../../components/Button/Button';
import { ServiceErrorMessages } from '../../constants/ServiceErrors';
import * as StoreUtils from '../../store/StoreAccessor';

function closeModal(id) {
  const { dispatch } = StoreUtils.getStore();
  dispatch(Actions.Modal.closeModal(id));
}

export function* openModalStandard(passedConfig) {
  const id = passedConfig._id || uid('modal');
  const modalConfig = {
    modalType: 'ModalStandard',
    buttons: [],
    onClose: () => {
      closeModal(id);
      if (passedConfig.onClose) {
        passedConfig.onClose();
      }
    },
    ...passedConfig,
  };
  return yield put(Actions.Modal.openModal(modalConfig, id, 'ModalStandard'));
}

export function* openReadOnlyModeMessage() {
  const _id = uid('modal');
  const modalConfig = {
    title: <FormattedMessage {...ServiceErrorMessages.readOnlyModeHeaderMessage} />,
    body: <FormattedMessage {...ServiceErrorMessages.readOnlyModeBodyMessage} />,
    _id,
    buttons: [
      <Button key={0} classes={['Button--blockCenter ']} onClick={() => closeModal(_id)}>
        <FormattedMessage {...ServiceErrorMessages.ok} />
      </Button>,
    ],
  };
  return yield openModalStandard(modalConfig);
}

export function* openModalCoachmark({ bodyMessage, id: _id, values }) {
  const id = _id || uid('modal');
  const defaultMessage = bodyMessage.defaultMessage || bodyMessage;
  const body = React.isValidElement(bodyMessage) ? (
    bodyMessage
  ) : (
    <FormattedMessage id={id} defaultMessage={defaultMessage} values={bodyMessage.values} />
  );
  const modalConfig = {
    modalType: 'ModalCoachMark',
    title: '',
    body,
    id,
    onClose: () => {
      closeModal(id);
    },
    buttons: [],
    values,
  };
  return yield put(Actions.Modal.openModal(modalConfig, id, 'ModalCoachMark'));
}
